﻿export default {
name: 'accept-regret-conditions',
    data: () => ({
        accepted: ''
    }),
mounted() {
    this.$store.dispatch('updateValidState', {invalid: !this.accepted, blockId: this.blockid}); 
},
props: ['blockid'],
watch: {
    accepted: function(){
        this.$store.dispatch('updateValidState', {invalid: !this.accepted, blockId: this.blockid}); 
    }
}
}  